export default __webpack_public_path__ + "assets/fonts/5e5885360c071dd82742b983d565da96.woff2";